(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-finder-klaviyo-form"] && !Shopify.designMode) return;
  try {
    class KlaviyoForm extends HTMLElement {
    constructor() {
      super();
    }
    updateProperties() {
      const payload = {
        data: {
          type: 'profile',
          attributes: {
            email: this.data?.email,
            properties: this.data?.properties
          }
        }
      };
      const options = {
        method: 'POST',
        headers: {
          revision: '2026-01-15',
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify(payload)
      };
      return fetch(`https://a.klaviyo.com/client/profiles?company_id=${this.companyId}`, options)
      .then(res => res.text())
      .then(res => console.log(res))
      .catch(err => console.error(err));
    }
    submit(e) {
      e.preventDefault();
      const formData = new FormData(this.form);
      this.data = {
        first_name: formData?.get('first_name') ?? null,
        email: formData?.get('email') ?? null,
        properties: {
          productfinder_answers: {},
          productfinder_result: {}
        }
      }
      const questions = Array.from(this.productfinder.querySelectorAll('[data-question]')).map(questionNode => ({
        name: questionNode.dataset.question,
        values: Array.from(questionNode.querySelectorAll('[data-answer]:checked')).map(answerNode => answerNode.dataset.answer)
      }));
      questions.forEach(question => {
        if(question.name){
          this.data.properties.productfinder_answers[question.name] = question.values;
        }
      });
      const currentAnswers = this.productfinder.querySelectorAll('.pf-question .pf-answer-input:checked');
      for (const answer of currentAnswers) {
        for (const [key, value] of Object.entries(answer.dataset)) {
          if(key.startsWith('score')){
            const formattedKey = key.replace('score', '').toLowerCase();
            if(typeof this.data.properties.productfinder_result[formattedKey] === 'number') {
              this.data.properties.productfinder_result[formattedKey] += Number(value);
            } else {
              this.data.properties.productfinder_result[formattedKey] = Number(value);
            }
          }
        }
      }
      const sortedResultKeys = Object.entries(this.data.properties.productfinder_result).sort((a, b) => b[1] - a[1]).map(([key, value]) => key);
      const encodedResultKeys = btoa(sortedResultKeys.join(',')).replaceAll('=', '').replaceAll('+', '-').replaceAll('/', '_');
      this.data.properties.productfinder_result.url = `${location.origin}${Shopify.routes.root}pages/product-finder-result?result=${encodedResultKeys}`;
      this.classList.add('loading');
      document.cookie = "__kla_off=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      if(klaviyo) {
        klaviyo.identify({
          first_name: this.data.first_name,
          email: this.data.email,
          consent: ['sms', 'email']
        })
        .then(() => {
          return klaviyo.isIdentified()
        })
        .then(isIdentified => {
          if(!isIdentified) {
            throw new Error("cusomter could not be idetified");
          }
          return this.updateProperties();
        })
        .then(response => {
          return klaviyo.track('Productfinder Completion', this.data);
        })
        .then(response => {
          this.classList.remove('loading');
          this.classList.add('success');
          console.log('profile and event successfully send');
        })
        .catch(error => {
          this.classList.remove('loading');
          this.classList.add('error');
          console.error('error creating profile or event', error);
        });
      }
    }
    connectedCallback() {
      this.productfinder = this.closest('product-finder');
      this.form = this.querySelector('form');
      this.companyId = this.getAttribute('company-id');
      if(this.form && this.companyId){
        this.form.addEventListener('submit', this.submit.bind(this));
      }
    }
  }
  if(!customElements.get('klaviyo-form')) {
    customElements.define('klaviyo-form', KlaviyoForm);
  }
  } catch(e) { console.error(e); }
})();

})();
